import { WidgetProps } from '@rjsf/core';
import React from 'react';
import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';
import classes from './style.module.scss';

const removeMSFromISO = (date: string) => `${date.split('.')[0]}Z`;
const formatDateResult = (date: moment.Moment | null, format = 'iso') => {
  if (!date) {
    return undefined;
  }
  if (format === 'iso') {
    return removeMSFromISO(date.toISOString());
  }
  if (format === 'timestamp') {
    // convert timestamp from milliseconds to seconds
    return date.valueOf() / 1000;
  }
  return date.format(format);
};

interface DateWidgetProps extends WidgetProps {
  disabledDate?: (date: Moment) => boolean;
}

const DateWidget = (props: DateWidgetProps) => {
  const { uiSchema, disabled, value, onChange, disabledDate } = props;
  const options = uiSchema['ui:options'] || {};
  let format = (options?.format as string) || 'YYYY-MM-DDTHH:mm:ssZ';
  if (format === 'YYYY-MM-DDTHH:mm:ssZ') {
    format = 'iso';
  }
  let originalValue: string | number = value;

  if (format === 'timestamp' && typeof originalValue === 'number') {
    // convert timestamp from seconds to milliseconds for moment
    originalValue = value * 1000;
  }

  const momentValue = (originalValue && moment(originalValue)) || undefined;

  return (
    <DatePicker
      className={classes.dateWidget}
      allowClear={false}
      disabledDate={(currentDate) =>
        disabledDate ? disabledDate(currentDate) : currentDate.isAfter(moment())
      }
      {...options}
      format="MMM DD, YYYY"
      disabled={disabled}
      onChange={(date) => {
        onChange(formatDateResult(date!.startOf('d'), format));
      }}
      value={momentValue}
    />
  );
};

export default DateWidget;
